export let REMOTE_VIDEO_EVENTS = /*#__PURE__*/function (REMOTE_VIDEO_EVENTS) {
  REMOTE_VIDEO_EVENTS["START"] = "start";
  REMOTE_VIDEO_EVENTS["DOWNLOADING"] = "remote-upload:downloading";
  REMOTE_VIDEO_EVENTS["UPLOADING"] = "remote-upload:uploading";
  REMOTE_VIDEO_EVENTS["UPLOAD_SUCCESS"] = "remote-upload:success";
  REMOTE_VIDEO_EVENTS["TRANSCODING_START"] = "transcoding:start";
  REMOTE_VIDEO_EVENTS["SUCCESS"] = "success";
  REMOTE_VIDEO_EVENTS["ERROR"] = "error";
  REMOTE_VIDEO_EVENTS["CHANGE"] = "change";
  return REMOTE_VIDEO_EVENTS;
}({});
//# sourceMappingURL=remote-video-events.js.map